type Iri = string;

type IriRef = { '@id': Iri };

export type ShopSaleDishSize = {
  mealType: IriRef | Iri;
  size: Iri;
  availableInFixedOffer?: boolean;
  costInShop?: number | string | null;
};

const resolveIri = (value: IriRef | Iri) =>
  typeof value === 'string' ? value : value?.['@id'];

export const getDishSizeKey = (dishSize: ShopSaleDishSize) =>
  `${resolveIri(dishSize.mealType)}_${dishSize.size}`;

export const getBrandDishSizes = <TDishSize extends ShopSaleDishSize>(
  brandTypes: IriRef[],
  dishSizes: TDishSize[]
) => {
  const brandTypeIris = brandTypes.map(({ '@id': typeIri }) => typeIri);

  return dishSizes.filter(({ mealType }) =>
    brandTypeIris.includes(resolveIri(mealType))
  );
};

export const getFixedOfferDishSizes = <TDishSize extends ShopSaleDishSize>(
  dishSizes: TDishSize[]
) => dishSizes.filter(({ availableInFixedOffer }) => availableInFixedOffer);

export const parseVatValue = (
  value: string | number | null | undefined
): number | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const parsed = typeof value === 'number' ? value : parseFloat(value);

  return Number.isNaN(parsed) ? null : parsed;
};
